import { NativeStackHeaderProps, Stack } from 'expo-router';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import Button from 'shared/components/vxl/Button/Button';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import TitleLgText from 'shared/components/vxl/typography/primary/title/TitleLgText';
import {
  useViewDidFocusScreenAnalyticsEvent,
  useViewDidFocusTrackAnalyticsEvent,
} from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import { useBackHandler } from 'shared/hooks/useBackHandler/useBackHandler';
import useDismissToRootTab, {
  Tabs,
} from 'shared/hooks/useDismissToRootTab/useDismissToRootTab';
import theme from 'shared/styles/theme';

const EMPTY_NAV_BAR_TOP_SPACING = 40;

const ApplicationDecline = () => {
  const { t: translatedText } = useTranslation('payOverTime', {
    keyPrefix: 'applicationDecline',
  });

  const { bottom } = useSafeAreaInsets();

  useViewDidFocusScreenAnalyticsEvent({
    key: '/pay-over-time/application-decline',
  });

  useViewDidFocusTrackAnalyticsEvent({
    name: 'Pay Over Time Application Declined',
    customAttributes: {
      category: 'pay_over_time',
      source_name: 'pay_over_time_application_declined',
    },
  });

  const dismissToTab = useDismissToRootTab();

  const goHome = useCallback(() => {
    dismissToTab(Tabs.HOME);
  }, [dismissToTab]);

  useBackHandler(goHome);

  return (
    <View
      style={[
        styles.screen,
        {
          paddingBottom: bottom + theme.spacing.m,
        },
      ]}
    >
      <Stack.Screen
        options={{
          headerShown: true,
          gestureEnabled: false,
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar {...props} empty primaryIcon={null} />
          ),
        }}
      />
      <View style={styles.content}>
        <TitleLgText numberOfLines={0}>{translatedText('title')}</TitleLgText>
        <BodyBaseText numberOfLines={0}>{translatedText('body')}</BodyBaseText>
        <BodyBaseText numberOfLines={0}>
          {translatedText('followUp')}
        </BodyBaseText>
      </View>
      <View style={styles.buttonContainer}>
        <Button
          label={translatedText('button')}
          onPress={goHome}
          type="PRIMARY"
          width="FULL"
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
  content: {
    flex: 1,
    gap: theme.spacing.m,
    paddingHorizontal: theme.spacing.m,
    paddingTop: EMPTY_NAV_BAR_TOP_SPACING,
  },
  buttonContainer: {
    paddingHorizontal: theme.spacing.m,
  },
});

export default ApplicationDecline;
